import React from 'react';
import PropTypes from 'prop-types';
import { query } from 'services/graphql';
import { noop } from 'lodash';
import { PlaceholderContainer } from 'components/grid/data/style';

export const propTypes = {
  query: PropTypes.object.isRequired,
  children: PropTypes.func.isRequired,
  variables: PropTypes.object,
  onLoad: PropTypes.func,
  prepareLoadedData: PropTypes.func,
  waitForData: PropTypes.bool,
  defaultData: PropTypes.any,
  fetch: PropTypes.bool,
  fetchPolicy: PropTypes.string,
  placeholder: PropTypes.node,
};

class Data extends React.Component<any> {
  static propTypes = propTypes;

  static defaultProps = {
    variables: undefined,
    defaultData: undefined,
    waitForData: true,
    onLoad: noop,
    fetchPolicy: 'network-only',
    placeholder: null,
    prepareLoadedData: (data) => data,
    fetch: true,
  };

  state = {
    data: null,
    loading: true,
    error: null,
    variables: undefined,
  };

  componentDidMount() {
    this.executeRequest();
  }

  executeRequest = (variables?) => {
    const { fetch, query: graphQLQuery, fetchPolicy } = this.props;
    variables = variables ? variables : this.props.variables;

    if (!fetch) {
      return this.setDefaultData();
    }

    this.setState({ loading: true });

    this.setState({ variables });

    return query(graphQLQuery)(variables, { fetchPolicy }).then((response) => {
      this.setState({ loading: false });
      this.setData(response);
      return response;
    });
  };

  setDefaultData = () =>
    this.setState({ data: this.props.defaultData, loading: false });

  setData = (response, { initial = false } = {}) => {
    if (response.isFailure) {
      return this.setState({
        data: this.props.defaultData,
        loading: false,
        error: response.getErrorMessage(),
      });
    }

    const data = this.props.prepareLoadedData(response);

    const state = {
      data,
      loading: false,
      ...(initial ? { initiallyLoaded: true } : {}),
    };

    this.setState(state, () => {
      this.props.onLoad(data, response);
    });
  };

  fetch(variables) {
    return this.executeRequest(variables);
  }

  reFetch = () => {
    const { variables = this.props.variables } = this.state;
    return this.fetch(variables);
  };

  render() {
    const { data, loading, error } = this.state;
    const { waitForData, placeholder, children } = this.props;

    if (waitForData && data === null) {
      return <PlaceholderContainer>{placeholder}</PlaceholderContainer>;
    }

    // @ts-ignore
    return children({ data, fetch: this.fetch, loading, error });
  }
}

export default Data;
